/**
 * Schermteksten in het Duits.
 *
 * GEMAAKT DOOR EEN MACHINE uit teksten/nl.ts, met
 * server/scripts/vertaal-teksten.ts. Niet met de hand bijwerken: een
 * volgende ronde overschrijft het.
 *
 * Machinevertaling van een interface is een START. Knoppen zijn kort en
 * zonder context, en juist daar gaat het mis. Laat dit nakijken door
 * iemand die de taal spreekt voordat het naar echte gebruikers gaat.
 */
import type { Teksten } from './nl';

export const de: Teksten = {
  kamerOphalen: "Raum laden…",
  kamerWerktNiet: "Dieser Raum funktioniert nicht",
  serverReageertNiet: "Der Server reagiert nicht",
  probeerOpnieuw: "Erneut versuchen",
  vraagNieuweCode: "Bitte die Person, die den Code geteilt hat, um einen neuen. Ein Raum läuft nach ein paar Stunden ab.",
  welkeTaalSprekJij: "Welche Sprache sprichst du?",
  jouwStem: "Deine Stimme in der Übersetzung",
  man: "Mann",
  vrouw: "Frau",
  pincode: "PIN-Code",
  pincodeUitleg: "Den bekommst du von der Person, die den Code geteilt hat.",
  gaDeKamerIn: "Tritt dem Raum bei",
  kiesEerstJeTaal: "Wähle zuerst deine Sprache",
  microfoonAanvragen: "Mikrofon anfordern…",
  toestemmingUitleg: "Dein Browser fragt gleich nach der Berechtigung für das Mikrofon. Ohne diese kannst du nur tippen.",
  microfoonTestLink: "Erst dein Mikrofon testen",
  stemGaatMee: "In diesem Raum hört die andere Person neben der Übersetzung auch deine eigene Stimme.",
  alleenChatMelding: "Dieses Gespräch ist nur Chat. Du tippst deine Nachrichten und liest die Übersetzung; nichts wird vorgelesen.",
  verlooptOm: "Läuft ab um",
  nooitVasteKamer: "Nie, fester Raum",
  kamer: "Raum",
  tolkgesprek: "Dolmetschergespräch",
  juisteKamer: "Du bist im richtigen Raum. Gleich kannst du hier mitsprechen.",
  jij: "du",
  deAnder: "der andere",
  verbinden: "Verbinden…",
  verbonden: "Verbunden",
  verbindingKwijt: "Verbindung verloren. Erneuter Versuch…",
  wachtenOpAnder: "Du bist drin. Warte, bis der andere den QR-Code scannt.",
  allebeiInDeKamer: "Ihr seid beide im Raum.",
  anderIsWeg: "Der andere ist weg",
  anderSpreekt: "Der andere spricht…",
  jeKuntErNietIn: "Du kannst nicht beitreten",
  overgenomenTitel: "Auf einem anderen Gerät fortgesetzt",
  overgenomenUitleg: "Dieses Gespräch wurde gerade auf einem anderen Gerät geöffnet. Dort sprichst du weiter.",
  terug: "Zurück",
  geluidStaatUit: "Der Ton ist aus. Tippe irgendwo auf den Bildschirm.",
  tikHier: "hier tippen",
  bewaardTot: 'Gespeichert bis {tijd}',
  bewaardVast: "Fester Raum. Nachrichten bleiben 30 Tage gespeichert.",
  spreekIn: "Sprechen",
  luisteren: "Zuhören… Tippen zum Stoppen",
  uitschrijven: "Transkribieren…",
  tijdOmTeVerbeteren: "Zeit zum Verbessern",
  altijdZelfVersturen: "Immer selbst prüfen und senden",
  jijVerstuurtZelf: "Du sendest selbst",
  uit: "aus",
  sec: "Sek.",
  vertalingMeteenAfspelen: "Übersetzung sofort abspielen",
  typHierJeBericht: "Schreibe hier deine Nachricht…",
  stuur: "Senden",
  geenOpnameMogelijk: "Dieser Browser kann keinen Ton aufnehmen. Tippen funktioniert jedoch.",
  verstaanAls: "Verstanden als",
  tellerStaatStil: "Zähler steht still",
  versturen: "Senden",
  wis: "Löschen",
  jijZei: "du sagtest",
  vertaald: "übersetzt",
  duimOmhoog: "Das stimmt",
  duimOmlaag: "Das stimmt nicht",
  opnieuwProberenKnop: "Mit besserem Modell erneut versuchen",
  opnieuwProberenBezig: "Wird erneut übersetzt…",
  duimTranscriptWoordenlijstUitnodiging: "Falsch verstanden? Korrigiere es im Wörterbuch:",
  instellingenAanpassen: "Einstellungen anpassen",
  geldtVoorJullieBeiden: "Gilt für euch beide",
  alleenVoorJou: "Nur für dich",
  stuurMijnStemMee: "Meine eigene Stimme mitsenden",
  verbeterSpelfouten: "Rechtschreibfehler in meinem Text korrigieren",
  verbeterSpelfoutenUit: "Ausschalten zeigt an, was tatsächlich verstanden wurde, inklusive Fehlern.",
  alleenChat: "Nur Chat: keine Sprache, kein Mikrofon",
  alleenChatUitleg: "Ihr tippt beide. Übersetzung und Originaltext werden angezeigt; nichts wird vorgelesen.",
  aangepastDoorDeAnder: "Der andere hat die Einstellungen geändert.",
  foutSpraak: "Die Übersetzung ist da, aber es wurde kein Ton ausgegeben.",
  foutSpraakQuota: "Das Sprachguthaben für heute ist aufgebraucht. Der Text funktioniert weiterhin; die Sprachausgabe geht morgen wieder.",
  foutBudgetKamer: "Dieses Gespräch hat sein Limit erreicht, daher wird gerade nicht übersetzt. Wer das Gespräch erstellt hat, kann es erhöhen; danach funktioniert es sofort wieder.",
  foutBudgetMaand: "Das Monatsbudget der App ist aufgebraucht. Übersetzen klappt erst wieder, wenn der Administrator es anpasst.",
  foutTaal: "Diese Sprache ist nicht möglich: Ihr würdet beide dieselbe Sprache sprechen.",
  origineel: "Original",
  vertalen: "Übersetzen…",
  vertalenMislukt: "Übersetzung fehlgeschlagen.",
  opnieuwAfspelen: "Übersetzung erneut abspielen",
  hoorDeAnder: "Höre, wie der andere es selbst gesagt hat",
  woordenlijst: "Auffang-Wörterbuch",
  woordenlijstUitleg: "Versteht die App einen Namen oder Fachbegriff dauernd falsch? Lege hier fest, was gemeint ist.",
  hijHoort: "er versteht…",
  jijBedoelt: "du meinst…",
  ookVolgendeGesprekken: "Auch in folgenden Gesprächen — sonst gilt es nur hier",
  voegToe: "Hinzufügen",
  bezig: "Wird ausgeführt…",
  lijstNietGeladen: "Die Liste konnte nicht geladen werden.",
  toevoegenMislukt: "Hinzufügen fehlgeschlagen.",
  verwijderenMislukt: "Löschen fehlgeschlagen.",
  overal: "überall",
  verwijder: "Löschen",
  overDitGesprek: "Über dieses Gespräch",
  toon: "Tonfall der Übersetzung",
  sfeer: "Atmosphäre des Gesprächs",
  jouwPlek: "Dein Standort",
  hoeHetWerkt: "Der Server transkribiert deine Aufnahme und übersetzt sie in einem Rutsch. Deine eigene Stimme wird an den anderen übertragen.",
  kleinereTekst: "Kleinerer Text",
  grotereTekst: "Größerer Text",
  insprekenVerbergen: "Sprechen ausblenden",
  insprekenTonen: "Sprechen einblenden",
  toetsenbordVerbergen: "Tastatur ausblenden",
  toetsenbordTonen: "Tastatur einblenden",
  vormAutomatisch: "Automatisch",
  vormInformeel: "Du",
  vormFormeel: "Sie",
  sfeerNeutraal: "Neutral",
  sfeerZakelijk: "Geschäftlich",
  sfeerOfficieel: "Offiziell",
  sfeerVriendschappelijk: "Freundschaftlich",
  sfeerPartner: "Partner",
  foutKamerVol: "Dieser Raum ist voll. Es können nur zwei Personen beitreten.",
  plekBezetTitel: "Dein Platz ist besetzt",
  plekBezetUitleg: "Auf deiner Seite dieses Gesprächs sitzt schon jemand, in deiner Sprache. Meistens bist du das selbst: Das Gespräch ist noch auf einem anderen Gerät oder in einem anderen Tab offen. Schließ es dort und versuch es noch einmal. Manchmal dauert es anderthalb Minuten, bis der Platz frei ist.",
  plekBezetWissel: "Bist du es selbst? Gib WISSEL ein, um das Gespräch auf dieses Gerät zu holen. Das andere Gerät wird dann geschlossen.",
  plekBezetKnop: "Auf dieses Gerät holen",
  foutKamerVerlopen: "Dieser Raum ist abgelaufen oder geschlossen.",
  foutKamerOnbekend: "Dieser Raum existiert nicht.",
  foutPinNodig: "Dieser Raum erfordert einen PIN-Code.",
  foutPinFout: "Der PIN-Code ist falsch.",
  foutProtocol: "Die App und der Server verstehen sich nicht. Aktualisiere die Seite.",
  foutMicroGeweigerd: "Du hast den Zugriff auf das Mikrofon verweigert. Klicke auf das Schloss-Symbol in der Adressleiste und aktiviere es.",
  foutGeenMicro: "Kein Mikrofon gefunden. Schließe eines an und versuche es erneut.",
  foutMicroInGebruik: "Das Mikrofon wird von einem anderen Programm verwendet. Schließe dieses und versuche es erneut.",
  foutGeenHttps: "Das Mikrofon funktioniert nur über eine sichere Verbindung. Öffne diese Seite über https.",
  foutMicroOnbekend: "Das Mikrofon konnte nicht gestartet werden.",
  foutNietsOpgenomen: "Es wurde nichts aufgenommen. Ist dein Mikrofon eingeschaltet?",
  foutNietsGehoord: "Nichts gehört. Ist dein Mikrofon an und sprichst du laut genug?",
  foutOpnameTeLang: "Diese Aufnahme ist zu lang. Sprich in kürzeren Abschnitten.",
  foutMicroGedempt: "Dein Mikrofon ist stummgeschaltet. Schalte es ein und versuche es erneut.",

  // --- microfoontest ---
  micTitel: "Mikrofontest",
  micOnderschrift: "Vier Tests nacheinander, je fünf Sekunden. Sprich die ganze Zeit weiter.",
  micStart: "Test starten",
  micTest1: "1. Nur erkennen",
  micTest2: "2. Nur aufnehmen",
  micTest3: "3. Zusammen — Aufnahme zuerst",
  micTest4: "4. Zusammen — Erkennung zuerst",
  micFase1: "1 von 4: nur erkennen — sag einen kurzen Satz",
  micFase2: "2 von 4: nur aufnehmen — sprich weiter",
  micFase3: "3 von 4: Aufnahme zuerst, dann Erkennung — sprich weiter",
  micFase4: "4 von 4: Erkennung zuerst, dann Aufnahme — sprich weiter",
  micKlaar: "fertig",
  micGehoord: "gehört",
  micOpnameformaat: "Aufnahmeformat",
  micGeen: "keins",
  micBeveiligd: "Sichere Verbindung",
  micJa: "ja",
  micNee: "NEIN",
  micBrowser: "Browser",
  micGeenHttps: "Ohne https gibt der Browser das Mikrofon nicht frei. Auf localhost ist es erlaubt.",
  micGeenHerkenning: "Dieser Browser kennt keine Spracherkennung.",
  micZegIets: "sag etwas…",
  micWoordenBinnen: "Wörter kommen an",
  micKonNietStarten: "konnte nicht starten",
  micGeenRecorder: "Dieser Browser kennt MediaRecorder nicht.",
  micOpnemen: "nimmt auf…",
  micNietsOpgenomen: "nichts aufgenommen",
  micGeenMicrofoon: "kein Mikrofon",
  micOpnameEerst: "Aufnahme zuerst…",
  micHerkenningEerst: "Erkennung zuerst…",
  micOpnameStarttNiet: "Aufnahme startete nicht",
  micSamenGelukt: "Zusammen. Aufnahme {kb} kB.",
  micAlleenOpname: "Aufnahme ja, Erkennung nein.",
  micAlleenHerkenning: "Erkennung ja, Aufnahme nein.",
  micGeenVanBeide: "Keins von beiden.",
  micNetwerkFout: "Die Spracherkennung konnte den Server nicht erreichen.",
  micAfgebroken: "Die Aufnahme wurde abgebrochen.",
  verslagTitel: "Gesprächsprotokoll",
  verslagWie: "Wer",
  verslagOrigineel: "Original",
  verslagVertaling: "Übersetzung",
  verslagSpreker: "Sprecher {x}",
  verslagBerichten: "Nachrichten",
  verslagGemaaktOp: "Erstellt",
  verslagGeenOpname: "Keine wörtliche Aufnahme.",
  verslagNootOrigineel: "„Original“ ist der Text, wie die App die sprechende Person verstanden hat.",
  verslagNootCorrectie: "Die Rechtschreibkorrektur war eingeschaltet: Kleine Tippfehler wurden korrigiert.",
  verslagNootAangepast: "Wer gesprochen hat, konnte den Text vor dem Senden noch ändern.",
  verslagGesproken: "gesprochen",
  verslagGetypt: "getippt",
  verslagMislukt: "Übersetzung fehlgeschlagen. Die andere Person hat diesen Satz nicht in ihrer Sprache gesehen.",
  verslagNietKlaar: "Die Übersetzung war noch nicht fertig, als dieses Protokoll erstellt wurde.",
  verslagVertrouwelijk: "Vertraulich.",
  verslagAlleenDeelnemers: "Dieses Protokoll enthält den Inhalt eines privaten Gesprächs und ist nur für die Teilnehmenden bestimmt.",
  verslagGewist: "Das Gespräch wird ab {tijd} gelöscht. Danach kann dieses Protokoll nicht erneut erstellt werden.",
  verslagGewistVast: "Fester Raum: Jede Nachricht wird 30 Tage nach dem Senden gelöscht. Ältere Nachrichten sind nicht in diesem Protokoll enthalten.",
};
